import { RootStore, PagedList, DeliveryPoint } from ".";
import { observable, action, runInAction } from "mobx";
import { formatDateJson } from "../common/Formatting";
import { fetchWrapper } from "../common/Fetch";
import { SuccessableResult } from "../common/BaseClasses";
import { NotificationLevel } from "./NotificationStore";
import { SOURCES_ABTEKA } from "../constants";

export interface DemandPosition {

    id: number;
    isReleased: boolean;
    releaseDate?: Date;
    orderGuid: string;
    orderNumber: number;
    customerId: string;
    customerName: string;
    customerPhone: string;
    deliveryPointName: string;
    supplierName: string;
    supSettingId: number;
    dateCreated: Date;
    brand: string;
    article: string;
    description: string;
    deliveryTimeString: string;
    statusName: string;
    count: number;
    costSale: number;
    acceptedCount: number;
    allowRelease: boolean;
    notifySended: boolean;
    notifyDate?: Date;
}

export class DemandsStore {

    _rootStore: RootStore;

    @observable demands: DemandPosition[] = [];
    @observable currentPage = 1;
    @observable totalOrdersCount = 1;
    @observable newRejectionsCount = 0;
    @observable deliveryPoints: DeliveryPoint[] = [];

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadDemands(page = 1, dateFrom?: Date, dateTo?: Date, deliveryPointId?: number) {
        this.demands = [];
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);

        fetchWrapper(`api/Demands/list/${page}?dateFrom=${dateFromStr}&dateTo=${dateToStr}&deliveryPointId=${deliveryPointId || ''}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<DemandPosition>>)
            .then(result => {
                runInAction("fetch complete loadOrders", () => {
                    this.currentPage = page;
                    this.totalOrdersCount = result.totalItemCount;
                    this.demands = result.items;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadDeliveryPoints() {
        fetchWrapper('api/DeliveryPoints/all/' + SOURCES_ABTEKA, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<DeliveryPoint[]>)
            .then(result => {
                runInAction("fetch complete loadDeliveryPoints", () => {
                    this.deliveryPoints = result;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }


    @action
    createDemand(demandNumber: string, positions: number[], comment: string, callback: () => void) {

        const data = {
            positions,
            comment,
            demandNumber
        };
        fetchWrapper('api/demands/SaveDemand', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete createDemand", () => {
                    if (result.isSuccess) {
                        if (result.errorMessage != undefined) {
                            this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.warning, -1);
                        }
                        else {
                            this._rootStore.notificationStore.addNotification("Отгрузка успешно сохранена!", NotificationLevel.success);
                            this.demands = this.demands.map(w => Object.assign({}, w, {
                                isReleased: w.isReleased || positions.indexOf(w.id) > -1,
                                releaseDate: w.releaseDate || new Date()
                            }))
                            callback();
                        }
                    }
                    else {
                        this._rootStore.notificationStore.addNotification("Ошибка при сохранении! " + result.errorMessage, NotificationLevel.error);
                    }
                });
            })
            .catch(res => {
                console.log(res);
            });
    }


    @action
    sendReadyNotifies(positionIds: number[]) {
        fetchWrapper(`api/Demands/SendNotifies`, {
            method: 'POST',
            body: JSON.stringify(positionIds),
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete sendReadyNotifies", () => {
                    if (result.isSuccess) {
                        if (result.errorMessage != undefined) {
                            this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.warning, -1);
                        }
                        else {
                            {
                                this._rootStore.notificationStore.addNotification("Уведомления отправлены!", NotificationLevel.success);
                                this.demands = this.demands.map(w => Object.assign({}, w, { notifySended: w.notifySended || positionIds.indexOf(w.id) > -1 }))
                            }
                        }
                    }
                    else {
                        this._rootStore.notificationStore.addNotification("Ошибка при отправке уведомлений! " + result.errorMessage, NotificationLevel.error);
                    }

                });
            })
            .catch(res => {
                console.log(res);
            });
    }
}